import React, {Fragment, useEffect, useState} from 'react';
import {connect} from "react-redux";

import ReleveHeader from "./Releves/ReleveHeader";
import Icon from "@mdi/react";
import {mdiLockOutline} from "@mdi/js";


const RelevePropPanel = (props) => {

    const [isLoading, setIsLoading] = useState(false)
    const [parcelles, setParcelles] = useState([])
    const winHeight = $(document).height();

    useEffect(()=>{
        setParcelles(props.currentParcelles)
    }, [props.currentParcelles])


    return (
        <div className={'card ueThemeBackground border-0'} style={{"padding":"10px"}}>
            <div className="card-body px-2" style={{userSelect: 'none'}} >
                <div className="row">
                    <div className="col-12 px-0" >
                        {
                            (props?.userAccessLevel?.isLeader || props?.userAccessLevel?.user_prefs?.access?.filter(e=>(e.name==="relev_prop"&& e.checked===true)).length>0)
                                ? <ReleveHeader keypar={parcelles} parcelles={props.currentParcelles}/>
                                :<div className={"d-flex flex-column justify-content-center align-items-center  p2"}>
                                    <Icon path={mdiLockOutline} size={1} />
                                    <div className={"text-center my-2"}>Votre compte ne vous permet pas d'acceder à cette fonctionnalité !</div>
                                </div>
                        }

                    </div>
                </div>
            </div>
        </div>
    );
};


const mapStateToProps = state => {
    return {
        currentParcelles: state.MapReducer.currentParcelle,
        showCurrentTab: state.LeftPanelReducer.showCurrentTab,
        userAccessLevel: state.MeReducer.access_level,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        showTabPanel: (e)=> dispatch({type: 'TOGGLE_PANEL_TAB', data:{currentTab: e}}),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(RelevePropPanel);
